import React, { useEffect, useState } from "react";
import "../css/OfferDetails.css";
import Header from "../components/Header";
import AboutThisOffer from "../components/offerDetails/AboutThisOffer";
import GetDirectionToShop from "../components/offerDetails/GetDirectionToShop";
import BottomNav from "../components/BottomNav";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import OfferTemplateRenderer from "../components/offerDetails/offerTemplates/OfferTemplateRenderer";
import { RelatedOffers } from "../components/offerDetails/RelatedOffers";
import OfferMediaCarousel from "../components/adminDashboard/offerMedia/OfferMediaCarousel";

export default function OfferDetailScreen() {
	const [tab, setTab] = useState("offers");
	const location = useLocation();
	const navigate = useNavigate();
	const [offer, setOffer] = useState(location.state?.data || null);
	const [distanceKm, setDistanceKm] = useState(
		location.state.distanceKm || 5,
	);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (location.state?.data) {
			setOffer(location.state.data);
			setDistanceKm(location.state.distanceKm || 5);

			window.scrollTo({
				top: 0,
				behavior: "smooth",
			});
		}
	}, [location.state]);

	if (loading) return <div className="text-white p-4">Loading...</div>;

	if (!offer) return <div className="text-white p-4">Offer not found</div>;
	return (
		<div className="app">
			<div className="offer-details-header-info-section p-2">
				<div className="hero">
					<OfferTemplateRenderer
						data={offer}
						type={offer.offerTemplate || "dark"}
						previewUrl={offer.image}
					/>
				</div>
			</div>

			<AboutThisOffer offer={offer} />
			{/* sample iamge carousel should display here */}
			<OfferMediaCarousel media={offer.media || []} />
			<GetDirectionToShop offer={offer} />
			<RelatedOffers currentOffer={offer} distanceKm={distanceKm} />
			<BottomNav active={tab} setActive={setTab} />
		</div>
	);
}
